/**
 * NavBar.js — боковое меню платформы (sidebar слева на desktop, справа на mobile).
 *
 * ═══════════════════════════════════════════════════════════════════
 * ГДЕ ЭТО ОТОБРАЖАЕТСЯ
 * ═══════════════════════════════════════════════════════════════════
 * NavBar рендерится внутри PersonalDefaultPage — обёртки всех страниц
 * личного кабинета (/service/..., /billing, игры и т.д.).
 *
 * ═══════════════════════════════════════════════════════════════════
 * СТРУКТУРА ФАЙЛОВ (папка navBar/)
 * ═══════════════════════════════════════════════════════════════════
 * navBarConstants.js      — MIN_WIDTH_FOR_MENU, число нижних пунктов меню
 * navBarUtils.js          — isDesktopMenuLayout, isMenuItemSelected
 * MenuItem.js             — одна строка меню (иконка + текст)
 * NavMenu.js              — список пунктов + слот для рефералки
 * MobileMenuToggle.js     — кнопка «гамбургер» на mobile
 * NavBarSubscriptionBlock.js — логотип, подписка, Управлять, Админка
 *
 * ═══════════════════════════════════════════════════════════════════
 * РЕФЕРАЛКА (папка blocks/referral/)
 * ═══════════════════════════════════════════════════════════════════
 * ReferralSidebarCard.js  — красная карточка в меню (только desktop)
 * ModalHowReferalWorks.js — модалка «Как это работает»
 * referralContent.js      — тексты шагов / карточек / «Важно»
 * ReferralModalParts.js   — блоки вёрстки модалки
 *
 * ═══════════════════════════════════════════════════════════════════
 * ЧТО ЗА ЧТО ОТВЕЧАЕТ В ЭТОМ ФАЙЛЕ
 * ═══════════════════════════════════════════════════════════════════
 * - referralOpen          — открыта ли модалка «Как работает рефералка»
 * - isOpen                — открыт ли sidebar на mobile (burger menu)
 * - бургер скрывается     — пока открыта рефералка, чтобы не торчать поверх оверлея
 * - ModalHowReferalWorks  — модалка с кодом и правилами (по «Пригласить»)
 * - ReferralSidebarCard   — красная карточка в меню (только desktop-sidebar)
 * - белый блок sidebar    — контейнер шириной 240px с закруглениями
 */

import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { color_white } from "../constants/colors";
import zoomUtil from "../utilities/zoom";
import { useWindowDimensions } from "../utils";
import ModalHowReferalWorks from "./blocks/referral/ModalHowReferalWorks";
import ReferralSidebarCard from "./blocks/referral/ReferralSidebarCard";
import MobileMenuToggle from "./navBar/MobileMenuToggle";
import NavBarSubscriptionBlock from "./navBar/NavBarSubscriptionBlock";
import NavMenu from "./navBar/NavMenu";
import { MIN_WIDTH_FOR_MENU } from "./navBar/navBarConstants";
import { isDesktopMenuLayout } from "./navBar/navBarUtils";

export { MIN_WIDTH_FOR_MENU };

const NavBar = () => {
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();

  const [isOpen, setIsOpen] = useState(false);
  const [referralOpen, setReferralOpen] = useState(false);

  React.useEffect(zoomUtil, []);

  const desktopMenu = isDesktopMenuLayout(location.pathname, screenWidth);

  return (
    <>
      {/* Модалка рефералки — поверх всего экрана, не внутри sidebar */}
      <ModalHowReferalWorks
        isOpen={referralOpen}
        onClose={() => setReferralOpen(false)}
        referal_code={user.referal_code}
      />

      {/* Burger скрыт, пока открыта рефералка — иначе z-index 2000 торчит поверх оверлея */}
      {!desktopMenu && !referralOpen && (
        <MobileMenuToggle
          isOpen={isOpen}
          onToggle={() => setIsOpen((prev) => !prev)}
        />
      )}

      {/* Белая панель меню: на desktop всегда видна, на mobile выезжает справа */}
      <div
        style={{
          position: desktopMenu ? "relative" : "fixed",
          top: 0,
          right: desktopMenu ? "auto" : 0,
          zIndex: 1000,
          transition: "width 0.3s ease-in-out",
          flex: desktopMenu ? "0 0 240px" : undefined,
          width: desktopMenu ? 240 : isOpen ? 240 : 0,
          minWidth: desktopMenu ? 240 : undefined,
          maxWidth: desktopMenu ? 240 : undefined,
          height: desktopMenu
            ? screenWidth >= 1600
              ? screenHeight
              : "100%"
            : screenHeight,
          backgroundColor: color_white,
          paddingBottom: 140,
          boxSizing: "border-box",
          overflowY: "auto",
          overflowX: "hidden",
          borderTopRightRadius: desktopMenu ? 40 : 0,
          borderBottomRightRadius: desktopMenu ? 40 : 0,
          borderTopLeftRadius: desktopMenu ? 0 : 40,
          borderBottomLeftRadius: desktopMenu ? 0 : 40,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            overflowX: "hidden",
          }}
        >
          <NavBarSubscriptionBlock user={user} screenHeight={screenHeight} />

          <div style={{ marginTop: screenHeight < 760 ? 10 : 60 }}>
            <NavMenu
              footer={
                desktopMenu ? (
                  <ReferralSidebarCard
                    onInviteClick={() => setReferralOpen(true)}
                  />
                ) : null
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;
